import { Button, Col, Modal, Popconfirm, Row } from 'antd'
import React, { Component } from 'react'
import InvoiceForm from './InvoiceForm'

class InvoiceModal extends Component {
  render() {
    const {
      type,
      visible,
      invoice,
      onCancel,
      submitting,
      submit,
      update,
      removing,
      remove,
      fetchingInvoice,
      formRef,
      actions,
      centers,
    } = this.props
    const isUpdatable = actions.find((a) => a.key === 'update')
    const isConfirmed = ['Confirmed'].includes(invoice.status)

    return (
      <Modal
        title={type !== 'edit' ? 'Create invoice' : 'Update Invoice'}
        visible={visible}
        onCancel={onCancel}
        width={'95%'}
        footer={
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              {type === 'edit' && !isConfirmed && (
                <Popconfirm title="Are you sure remove this invoice?" onConfirm={remove} okText="Yes" cancelText="No">
                  <Button type="danger" loading={removing} style={{ marginLeft: 8 }}>
                    Remove
                  </Button>
                </Popconfirm>
              )}
              <Button loading={submitting} type="primary" onClick={type !== 'edit' ? submit : update}>
                {type === 'edit' ? 'Update' : 'Submit'}
              </Button>
            </Col>
          </Row>
        }>
        <Row>
          <InvoiceForm
            ref={formRef}
            loading={fetchingInvoice}
            onChangeEmployee={this.onChangeEmployee}
            invoice={invoice}
            {...this.props}
            centers={centers}
          />
        </Row>
      </Modal>
    )
  }
}

InvoiceModal.propTypes = {}
InvoiceModal.defaultProps = {}

export default InvoiceModal
